export const ElectronEngineProviderFactory: IElectronEngineProviderFactory = ({
  electron,
}) => {
  const windowCircadiaStatus = !!electron;

  const isWindowElectron = () => {
    return windowCircadiaStatus;
  };

  return {
    isWindowElectron,
    signIn: electron?.signIn,
    signInWithPasswordless: electron?.signInWithPasswordless,
    confirmPasswordlessMFA: electron?.confirmPasswordlessMFA,
    currentSession: electron?.currentSession,
    currentUserInfo: electron?.currentUserInfo,
    setupPin: electron?.setupPin,
    verifyPin: electron?.verifyPin,
    retrieveTokens: electron?.retrieveTokens,
    confirmMFA: electron?.confirmMFA,
    signOut: electron?.signOut,
    completeNewPassword: electron?.completeNewPassword,
    listenToFCMToken: electron?.listenToFCMToken,
    notificationSoundOff: electron?.notificationSoundOff,
    changePassword: electron?.changePassword,
    changePin: electron?.changePin,
    forgotPassword: electron?.forgotPassword,
    confirmPassword: electron?.confirmPassword,
    checkPassword: electron?.checkPassword,
    checkPinStatus: electron?.checkPinStatus,
  };
};
